export default __webpack_public_path__ + "static/media/icon_search.fddb7f93.svg";